<template>
  <div>
    <el-form ref="formRef" :model="settleForm" label-width="100px">
      <el-form-item label="姓名：">
        <el-input type="text" v-model="settleForm.name" placeholder="输入姓名" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="手机号：">
        <el-input type="text" v-model="settleForm.phone" placeholder="输入手机号码" :maxlength="11" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="身份证号：">
        <el-input type="text" v-model="settleForm.idCard" placeholder="输入身份证号码" :maxlength="18" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="支付宝账号：">
        <el-input type="text" v-model="settleForm.account" placeholder="输入支付宝账号" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="提现金额：">
        <el-input type="text" v-model="settleForm.money" placeholder="输入提现金额" style="width:24em;"/>
        <p style="font-size: 12px;"><span style="color: red">*</span>提现金额需大于0</p>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input :rows="4" type="textarea" v-model="settleForm.remark" placeholder="输入备注内容" style="width:24em;"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateThirdSettlement } from "@/api/url";
import { phoneReg, moneyReg} from "@/assets/shared/reg-constant";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      settleForm: this.value.settleForm,
      idx: this.value.ids,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.settleForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '姓名不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.settleForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '姓名不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.settleForm.phone) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '手机号不能为空',
          type: 'warning'
        });
        return false
      } else if (!phoneReg.test(this.settleForm.phone)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '手机号格式不正确',
          type: 'warning'
        });
        return false
      }
      if(!this.settleForm.idCard) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '身份证号不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.settleForm.account) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '支付宝账号不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.settleForm.money) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '提现金额不能为空',
          type: 'warning'
        });
        return false
      }else if (!moneyReg.test(this.settleForm.money)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '提现金额格式不正确',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.settleForm.id?this.settleForm.id:0;
      param['name'] = this.settleForm.name;
      param['phone'] = this.settleForm.phone;
      param['idCard'] = this.settleForm.idCard;
      param['account'] = this.settleForm.account;
      param['money'] = this.settleForm.money;
      param['remark'] = this.settleForm.remark;
      postFormData(addOrUpdateThirdSettlement, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
